<template>
  <q-card flat bordered class="q-mt-md">
    <q-card-section class="bg-blue-1">
      <div class="row items-center">
        <q-icon name="lightbulb" color="amber" size="24px" class="q-mr-sm" />
        <span class="text-weight-medium">Tip</span>
      </div>
    </q-card-section>
    <q-card-section>
      <ul class="q-pl-md text-caption text-grey-7">
        <!-- Slot para tips personalizados o por defecto -->
        <slot>
          <li>Presiona <kbd>Ctrl + S</kbd> para guardar rápido</li>
          <li>Los campos marcados con <q-icon name="error" size="14px" color="warning" /> son requeridos</li>
        </slot>
      </ul>
    </q-card-section>
  </q-card>
</template>

<style lang="scss" scoped>
kbd {
  background: #f4f4f4;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 2px 6px;
  font-family: monospace;
  font-size: 0.85em;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
</style>
